/**
 * A utility function to Add or Remove class on selected element
 */
const AddorRemoveClass = (element, className, add) => {
    if (!element) {
        return;
    }
    if (add) {
        element.addClass(className);
        return;
    }

    if (typeof element.removeClass === 'function') {
        element.removeClass(className);
    } else {
        element.classList.remove(className);
    }
};
export default AddorRemoveClass;
